import {VideoAvatarList} from './VideoAvatarsList';
export default VideoAvatarList;
